<template>
	<div id="dashboard-header">
		<div class="col md-4 left">
			<div class="dash__title">Dashboard</div>
		</div>
		<div class="col md-8 dash__controls">
			<router-link  
				v-if="!isEditAccount"
		        :to="{ path : '/create/select-area'}" 
		        exact
		        class="btn outline db-button"
		        >
		        <span>Create New +</span>
		    </router-link>
			
			<router-link  
				v-if="!isEditAccount"
		        :to="{ path : '/dashboard/editaccount'}" 
		        exact
		        class="btn outline db-button"
		        >
		        <span>Edit Account</span>
		    </router-link>

		    <router-link 
		    	v-if="isEditAccount"
		    	:to="{ path : '/dashboard'}" 
		        exact
		        class="btn"
		        >
		        <span>Back to dashboard</span>
		    </router-link>	

			<button class="btn outline db-button" @click="logout">Logout</button>
		</div>
		<div class="clearfix"></div>
	</div>
</template>

<script>
	export default {
		computed : {
			isEditAccount(){
 	 	    	return this.$route.name === 'editaccount';
    		}
		},
		methods : {
			logout(){
				this.$store.dispatch('userLogout');
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Dashboard/DBHeader.vue